module.exports = __webpack_public_path__ + "img/downloads_prospekt.15d23576.jpg";